import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseTemperoryUploadVariables {
  file: any;
}

export interface UseTemperoryUploadData {
  image: string;
  uuid: string;
}

export function useTemperoryUpload() {
  return useMutation<
    UseTemperoryUploadData,
    AxiosError<UseTemperoryUploadData>,
    UseTemperoryUploadVariables
  >((variables) => {
    var formData = new FormData();
    formData.append('image', variables.file);

    return axios
      .post<UseTemperoryUploadData>(
        '/posht/negar/temporary-upload/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((res) => res.data);
  });
}
